import * as React from "react";
import { IDocumentNameElement } from "../Document/DocumentsView";
import { IconType, MimeTypeIcon } from "../Icons/MimeTypeIcon";
import * as Utilities from "../Utilities";
import { Link } from "./Link";
import {
	TooltipHost,
	TooltipDelay,
	DirectionalHint,
	ITooltipProps,
} from "office-ui-fabric-react";
import { CoverPreview } from "./CoverPreview";

export class FileLink extends React.Component<IDocumentNameElement, {}> {
	tooltipProps: ITooltipProps = {
		onRenderContent: () => (
			<CoverPreview
				isCoverAvailable={this.props.isCoverAvailable}
				fileLinkGuid={this.props.fileLinkGuid}
			/>
		),
	};
	render() {
		return (
			<Link
				to={Utilities.getDeepLinkReaderUrl(
					this.props.documentId,
					this.props.language,
					this.props.name,
					this.props.mimeType
				)}
				className="link-document is--mimetype-link"
				testName={this.props.testName}
				testId={this.props.testId}
				onClick={this.props.onClick}
			>
				{!this.props.hideMimeTypeIcon ? (
					<TooltipHost
						tooltipProps={this.tooltipProps}
						delay={TooltipDelay.zero}
						id={"tooltipIcon"}
						directionalHint={DirectionalHint.bottomLeftEdge}
					>
						<MimeTypeIcon
							mimeType={Utilities.getDisplayMimetype(
								this.props.mimeType
							)}
							iconType={IconType.Png16}
						/>
					</TooltipHost>
				) : null}
				<span>{this.props.name}</span>
			</Link>
		);
	}
}
